import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class {

    constructor() {
        gsap.registerPlugin(ScrollTrigger)

        barba.hooks.once((data) => {
            this.run()
            setTimeout(() => {
                this.movConfirmation()
            }, 100);
        })
        barba.hooks.leave((data) => {
            window.removeEventListener('resize', this.resize)
        })
        barba.hooks.after((data) => {
            this.run()
            setTimeout(() => {
                this.movConfirmation()
            }, 100);
        });
    }

    run() {
        this.resize()
        window.addEventListener('resize', this.resize)
        this.setupVideoHandlers();

        const leadSection = document.querySelector('.p-index__lead');
        const conceptSection = document.querySelector('.p-index__concept');

        if (leadSection) {
            // .p-index__catchが存在する場合の処理
            ScrollTrigger.create({
                trigger: conceptSection,
                start: "top top",
                end: "bottom top",
                pin: "#js-hero__mov",
                pinSpacing: false,
                scrub: true,
                //markers: true
            });
        }
    }

    movConfirmation (){

        let isPlaying = false;
        const videoElements = document.getElementsByTagName('video');
        const stdEl = document.querySelectorAll(".std-el");
        const saveEl = document.querySelectorAll(".save-el");

        if (videoElements.length > 0) {
            //console.log(videoElements)
            const video = videoElements[0];
            video.play().then(() => {
                if (saveEl.length > 0) saveEl.forEach(el => el.style.display = 'none');
                if (stdEl.length > 0) stdEl.forEach(el => el.style.display = 'block');
            }).catch((error) => {
                if (stdEl.length > 0) stdEl.forEach(el => el.style.display = 'none');
                if (saveEl.length > 0) saveEl.forEach(el => el.style.display = 'block');
            });
        }
    }
    
    resize() {
        this.kv = document.querySelectorAll('#kv-movie')
        if (this.kv.length > 0) {
            this.kv.forEach(el => {
                const resizeWidth = (window.outerHeight * 1.7778).toFixed(0)
                const resizeHeight = (window.outerWidth * 0.5625).toFixed(0)
                // portrait 
                if (window.outerWidth < window.outerHeight || resizeHeight < window.outerHeight) {
                    el.style.height = window.outerHeight + 'px'
                    el.style.width = resizeWidth + 'px'
                // landscape
                } else if (window.outerWidth > window.outerHeight || resizeWidth) {
                    el.style.height = resizeHeight + 'px'
                    el.style.width = window.outerWidth + 'px'
                }
            })
        }
    }

    setupVideoHandlers() {
        const videosContainer = document.getElementById("js-hero__mov");
        //const modalVideo = document.querySelector(".modal__mov");
    
        function getVideoItems() {
            if (window.innerWidth > 991) {
                return videosContainer.querySelectorAll(".js-hero__mov__item.--pc");
            } else {
                return videosContainer.querySelectorAll(".js-hero__mov__item.--sp");
            }
        }
    
        let videoItems = getVideoItems();
        const videos = Array.from(videoItems).map(item => item.querySelector("video"));
        const sources = {
            pc: [
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_A1_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_A2_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_B1_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_B2_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_AB1_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_AB2_low.mp4"
            ],
            mobile: [
                //"https://willstyle.s3.ap-northeast-1.amazonaws.com/kawasaki-life.jp/insurance-group.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spA1_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spAB2_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spB1_low.mp4",
                "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spB2_low.mp4"
            ]
        };
    
        let playedVideos = [];
        const muteButton = document.getElementById("muteButton");
    
        muteButton.addEventListener("click", function() {
            // Display blockになっているvideoのみを対象とする
            const visibleVideo = Array.from(videoItems).find(item => item.style.display === 'block').querySelector("video");
            if (visibleVideo) {
                const isMuted = visibleVideo.muted;
                visibleVideo.muted = !isMuted;
                if (visibleVideo.muted) {
                    muteButton.classList.remove("unmute");
                } else {
                    muteButton.classList.add("unmute");
                }
            }
        });
        

        function updateVideoSources() {
            const deviceType = window.innerWidth <= 991 ? 'mobile' : 'pc';
            videos.forEach((video, index) => {
                setTimeout(() => {
                    video.src = sources[deviceType][index];
                    video.load();
                }, index * 150); // 150msの遅延を追加
            });
        }
    
        function playRandomVideo() {
            if (videos.length === playedVideos.length) {
                playedVideos = [];
            }
        
            let videoItemToPlay;
            do {
                const randomIndex = Math.floor(Math.random() * videoItems.length);
                videoItemToPlay = videoItems[randomIndex];
            } while (playedVideos.includes(videoItemToPlay.querySelector("video")));
        
            playedVideos.push(videoItemToPlay.querySelector("video"));
            Array.from(videoItems).forEach(item => item.style.display = 'none');
        
            setTimeout(() => {
                videoItemToPlay.style.display = 'block';
                const video = videoItemToPlay.querySelector("video");
                video.muted = true; // 新しい動画を再生するときにミュート状態にする
                muteButton.classList.remove("unmute"); // 新しい動画の再生時にボタンのクラスをリセットする
                video.play();
                video.onended = playRandomVideo; // 次の動画を再生
            }, 500); // 0.5秒のブランクを設ける
        }
        
    
        playRandomVideo();
        updateVideoSources();
    }
    

    
    // setupVideoHandlers() {
    //     const videosContainer = document.getElementById("js-hero__mov");
    //     const modalVideo = document.querySelector(".modal__mov");

    //     function getVideoItems() {
    //         if (window.innerWidth > 575) {
    //             return videosContainer.querySelectorAll(".js-hero__mov__item.--pc");
    //         } else {
    //             return videosContainer.querySelectorAll(".js-hero__mov__item.--sp");
    //         }
    //     }

    //     let videoItems = getVideoItems();
    //     const videos = Array.from(videoItems).map(item => item.querySelector("video"));
    //     const sources = {
    //         pc: [
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_A1_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_A2_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_B1_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_B2_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_AB1_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_AB2_low.mp4"
    //         ],
    //         mobile: [
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spA1_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spAB2_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spB1_low.mp4",
    //             "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/kv/asunaro_spB2_low.mp4"
    //         ]
    //     };
    //     let playedVideos = [];
    //     const muteButton = document.getElementById("muteButton");

    //     muteButton.addEventListener("click", function() {
    //         const isMuted = videos[0].muted;
    //         videos.forEach(video => video.muted = !isMuted);
    //     });

    //     function updateVideoSources() {
    //         const deviceType = window.innerWidth <= 575 ? 'mobile' : 'pc';
    //         videos.forEach((video, index) => {
    //             video.src = sources[deviceType][index];
    //             video.load();
    //         });
    //     }

    //     function playRandomVideo() {
    //         if (videos.length === playedVideos.length) {
    //             playedVideos = [];
    //         }

    //         let videoItemToPlay;
    //         do {
    //             const randomIndex = Math.floor(Math.random() * videoItems.length);
    //             videoItemToPlay = videoItems[randomIndex];
    //         } while (playedVideos.includes(videoItemToPlay.querySelector("video")));

    //         playedVideos.push(videoItemToPlay.querySelector("video"));
    //         Array.from(videoItems).forEach(item => item.style.display = 'none');
    //         videoItemToPlay.style.display = 'block';
    //         const video = videoItemToPlay.querySelector("video");
    //         video.play();
    //         video.onended = playRandomVideo;

    //         // Update the modal video source
    //         modalVideo.src = video.src;
    //         modalVideo.load();
    //     }

    //     playRandomVideo();
    //     updateVideoSources();
    // }
}


/////////////////////

// import barba from '@barba/core';

// export default class{

// 	constructor(){

//         barba.hooks.afterOnce((data) => {
//             this.run()
//         })
//         barba.hooks.leave((data) => {
//             window.removeEventListener('resize', this.resize)
//         })
//         barba.hooks.after((data) => {
//             this.run()
//         });
//     }
//     run () {
//         this.resize()
//         window.addEventListener('resize', this.resize)
//         this.setupVideoHandlers();
//     }
//     resize(){
//         this.kv = document.querySelectorAll('#kv-movie')
//         if(this.kv.length > 0){
//             this.kv.forEach( el => {
//                 const resizeWidth = (window.outerHeight * 1.7778).toFixed(0)
//                 const resizeHeight = (window.outerWidth * 0.5625).toFixed(0) 
//                 // portrait 
//                 if(window.outerWidth < window.outerHeight || resizeHeight < window.outerHeight){
//                     el.style.height = window.outerHeight + 'px'
//                     el.style.width = resizeWidth + 'px'
//                 // landscape
//                 } else if(window.outerWidth > window.outerHeight || resizeWidth){
//                     el.style.height = resizeHeight + 'px'
//                     el.style.width = window.outerWidth + 'px'
//                 }
//             })
//         }
//     }
//     setupVideoHandlers() {
//         // const videosContainer = document.getElementById("js-hero__mov");
//         // const videoItems = videosContainer.querySelectorAll(".js-hero__mov__item"); // ビデオの親要素を取得
//         const videosContainer = document.getElementById("js-hero__mov");

//         // 画面サイズに基づいて異なるビデオアイテムを選択
//         function getVideoItems() {
//             if (window.innerWidth > 575) {
//                 return videosContainer.querySelectorAll(".js-hero__mov__item.--pc");
//             } else {
//                 return videosContainer.querySelectorAll(".js-hero__mov__item.--sp");
//             }
//         }

//         let videoItems = getVideoItems(); // 初期ロード時のビデオアイテムを取得
        
//         const videos = Array.from(videoItems).map(item => item.querySelector("video")); // 各ビデオ要素を取得
//         const sources = {
//             pc: [
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_A1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_B1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_AB1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_A1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_B1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_AB1.mp4"
//             ],
//             mobile: [
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_sp_A1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_sp_AB2.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_sp_B1.mp4",
//                 "https://willstyle.s3.ap-northeast-1.amazonaws.com/asunaro-corp.com/asunaro_sp_B1.mp4"
//             ]
//         };
//         let playedVideos = [];
//         const muteButton = document.getElementById("muteButton");

//         muteButton.addEventListener("click", function() {
//             const isMuted = videos[0].muted;
//             videos.forEach(video => video.muted = !isMuted);
//             if (video.paused) {
//                 video.play(); // ビデオが一時停止している場合は再生を試みる
//             }
//         });

//         function updateVideoSources() {
//             const deviceType = window.innerWidth <= 575 ? 'mobile' : 'pc';
//             videos.forEach((video, index) => {
//                 video.src = sources[deviceType][index];
//                 video.load();
//             });
//         }

//         function playRandomVideo() {
//             if (videos.length === playedVideos.length) {
//                 playedVideos = []; // すべての動画が再生されたらリセット
//             }

//             let videoItemToPlay;
//             do {
//                 const randomIndex = Math.floor(Math.random() * videoItems.length);
//                 videoItemToPlay = videoItems[randomIndex];
//             } while (playedVideos.includes(videoItemToPlay.querySelector("video")));

//             playedVideos.push(videoItemToPlay.querySelector("video"));
//             Array.from(videoItems).forEach(item => item.style.display = 'none');
//             videoItemToPlay.style.display = 'block';
//             const video = videoItemToPlay.querySelector("video");
//             video.play();
//             video.onended = playRandomVideo;
//         }

//         playRandomVideo();
//         updateVideoSources();
//         //window.addEventListener('resize', updateVideoSources);
//     }
// }